/*
  The quick entry bar's two rules, rebrand step 5 (brand guide 12.3), kept away
  from the screen so they can be tested.

  **It only looks at the lines already on the sheet**, which the screen has
  loaded. It never asks the database anything; adding an item that is not on
  the sheet is still the "Add an item" search's job.
*/

/*
  Which line a typed or scanned item number means. An exact item number first
  (ignoring capitals and the spaces round it), then a line whose name starts
  with the text. Among several lines for the same item (one per shelf), the
  first in the sheet's order.
*/
export function findLine(lines, text) {
  const q = String(text || '').trim().toLowerCase();
  if (!q) return null;
  const list = lines || [];
  return list.find(l => String(l.item_number_raw || '').trim().toLowerCase() === q)
    || list.find(l => String(l.description_raw || '').trim().toLowerCase().startsWith(q))
    || null;
}

/* A count is a whole number, nothing else: "12" yes, "12.5", "-3" and "a" no. */
export function wholeNumber(text) {
  const t = String(text ?? '').trim();
  return /^\d+$/.test(t) ? parseInt(t, 10) : null;
}
